import React from 'react';
import {
 Settings
} from 'lucide-react';
import PlaceholderPage from '../components/PlaceholderPage';

const SettingsPage: React.FC = () => {
    return (
        <PlaceholderPage
            title="Settings"
            icon={Settings}
            description="Configure your application settings and preferences."
        />
    );
};

export default SettingsPage;
